import AgenciesListLink from 'client/common/components/agencies-list-link';

import './index.css';

export default AgenciesListLink;
